
import { FC } from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage, Language } from '@/contexts/LanguageContext';
import SwedenFlag from './flags/SwedenFlag';
import UKFlag from './flags/UKFlag';

const LanguageSelector: FC = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'sv' : 'en');
  };

  // Show the flag of the language you can switch TO (not the current language)
  const targetLanguage = language === 'en' ? 'sv' : 'en';
  const flagData = {
    en: { flag: UKFlag, name: 'English', shortName: 'EN' },
    sv: { flag: SwedenFlag, name: 'Svenska', shortName: 'SV' }
  };

  const targetData = flagData[targetLanguage];
  const FlagComponent = targetData.flag;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 h-9 text-sm hover:bg-gray-100 border border-gray-200 rounded-md transition-all duration-200 hover:shadow-sm bg-white/80"
      title={`Switch to ${targetData.name}`}
    >
      <FlagComponent className="w-5 h-4 rounded-sm shadow-sm" />
      <span className="hidden sm:inline font-medium text-gray-700">
        {targetData.shortName}
      </span>
    </Button>
  );
};

export default LanguageSelector;
